var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDispatchIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.7072 4.70718L5.4143 13.0001H9V15.0001H3C2.44772 15.0001 2 14.5523 2 14.0001V8.00006H4V11.5859L12.293 3.29297L13.7072 4.70718Z",
  fill: "#864C13"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 11.0001H18.5859L10.293 19.293L11.7072 20.7072L20 12.4144V16.0001H22V10.0001C22 9.44778 21.5523 9.00006 21 9.00006H15V11.0001Z",
  fill: "#864C13"
})));
export { SvgDispatchIcon as ReactComponent };
export default __webpack_public_path__ + "assets/35bdfeee.svg";